import { render, staticRenderFns } from "./CommonPartOfSidebar.vue?vue&type=template&id=3a40d7d0&lang=pug&"
import script from "./CommonPartOfSidebar.vue?vue&type=script&lang=ts&"
export * from "./CommonPartOfSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CommonPartOfSidebar.vue?vue&type=style&index=0&id=3a40d7d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports